import { PropsWithChildren } from "react";
import { useBoardTemplatesModalProvider } from "@jugl-web/domain-resources/tasks/components/BoardTemplatesModal/providers/useBoardTemplatesModalProvider";
import { BoardTemplatesSidebar } from "./components/BoardTemplatesSidebar/BoardTemplatesSidebar";

export const BoardTemplatesLayout = ({ children }: PropsWithChildren) => {
  const { selectedTemplate } = useBoardTemplatesModalProvider();
  return (
    <div className="flex h-full flex-row overflow-hidden">
      {!selectedTemplate && (
        <div className="border-dark-200 jugl__custom-scrollbar w-[320px] min-w-[320px] overflow-y-auto overflow-x-hidden border-0 border-r-[1px] border-solid">
          <BoardTemplatesSidebar />
        </div>
      )}
      <div className="h-full w-full overflow-y-auto">{children}</div>
    </div>
  );
};
